import React from 'react';
import Helmet from 'react-helmet';

import cockpit from '../helpers/cockpit.js';

import AlternateTextAndImageBlock from 'Components/AlternateTextAndImageBlock';
import FourColumnsBlock from 'Components/FourColumnsBlock';
import Products from 'Components/Products/ProductsSlick';
import TextAndImageBlock from 'Components/TextAndImageBlock';
import ContactForm from 'Components/ContactForm';

import bgService from 'Images/teaser_hg_zahnraeder.jpg';
import bgGoal from 'Images/teaser_hg_diamanten.jpg';
import bgSecurity from 'Images/teaser_hg_combination_lock.jpg';
import bgProducts from 'Images/teaser_hg_montadrill.jpg';

function IndexPage({ data }) {
  const texts = data.texts;
  const commonTexts = data.commonTexts;
  const products = data.products.edges;

  return (
    <div>
      <Helmet
        title={texts.seo_title}
        meta={[
          { name: 'description', content: texts.seo_description },
          { name: 'keywords', content: texts.seo_keywords },
        ]}
      />

      <FourColumnsBlock data={
        [
          {
            title: texts.textbox_product_title,
            subtitle: texts.textbox_product_teaser,
            target: `#${texts.textbox_product_id}`,
            image: bgProducts,
          },
          {
            title: texts.textbox_service_title,
            subtitle: texts.textbox_service_teaser,
            target: `#${texts.textbox_service_id}`,
            image: bgService,
          },
          {
            title: texts.textbox_security_title,
            subtitle: texts.textbox_security_teaser,
            target: `#${texts.textbox_security_id}`,
            image: bgSecurity,
          },
          {
            title: texts.textbox_goal_title,
            subtitle: texts.textbox_goal_teaser,
            target: `#${texts.textbox_goal_id}`,
            image: bgGoal,
          },
        ]}
      />
      <Products
        data={{
          products,
          id: texts.textbox_product_id,
          text: texts.textbox_product_text,
        }}
      />
      <TextAndImageBlock
        data={{
          title: texts.textbox_service_title,
          text: texts.textbox_service_text,
          id: texts.textbox_service_id,
          image: texts.textbox_service_image.localFile.childImageSharp,
        }}
      />
      <TextAndImageBlock
        data={{
          title: texts.textbox_security_title,
          text: texts.textbox_security_text,
          id: texts.textbox_security_id,
          image: texts.textbox_security_image.localFile.childImageSharp,
        }}
        imagePosition="right"
      />
      <AlternateTextAndImageBlock
        data={{
          title: texts.textbox_goal_title,
          text: texts.textbox_goal_text,
          id: texts.textbox_goal_id,
          image: texts.textbox_goal_image.localFile.childImageSharp,
        }}
      />
      <ContactForm
        data={{
          title: texts.kontakt_title,
          teaser: texts.kontakt_teaser,
          phone: commonTexts.contact_telephone,
          email: commonTexts.contact_email,
          products,
        }}
      />
    </div>
  );
}

export default cockpit(IndexPage);

export const indexPageQuery = graphql`

  query indexPageQuery {
    products: allProduct(filter:{active:{eq:true}}) {
      edges {
        node {
          id
          brand
          name
          additionalName
          document_label
          shortdescription
          description
          profile {
            _isset
            profile 
          }
          attributes {
            _isset
            attributes
          }
        }
      }
    }
    
    commonTexts: regionCommon {
      contact_telephone
      contact_email
    }
      
    texts: regionHomepage {
      seo_title 
      seo_description
      seo_keywords
      
      textbox_service_title
      textbox_service_id
      textbox_service_teaser
      textbox_service_text
      textbox_service_image {
        localFile {
          childImageSharp {
            sqip(numberOfPrimitives: 12, blur: 12, width: 400) {
              dataURI
            }
            sizes(
              grayscale: false, 
              maxWidth: 600, 
              traceSVG: {optTolerance: 10, blackOnWhite: true},
            ) {
              ...GatsbyImageSharpSizes_noBase64
            }
          }
        }
      }
      textbox_security_title
      textbox_security_id
      textbox_security_teaser
      textbox_security_text
      textbox_security_image {
        localFile {
          childImageSharp {
            sqip(numberOfPrimitives: 12, blur: 12, width: 400) {
              dataURI
            }
            sizes(
              grayscale: false, 
              maxWidth: 600, 
              traceSVG: {optTolerance: 10, blackOnWhite: false},
            ) {
              ...GatsbyImageSharpSizes_noBase64
            }
          }
        }
      }
      textbox_goal_title
      textbox_goal_id
      textbox_goal_teaser
      textbox_goal_text
      textbox_goal_image {
        localFile {
          childImageSharp {
            sqip(numberOfPrimitives: 12, blur: 12, width: 400) {
              dataURI
            }
            sizes(
              grayscale: false, 
              maxWidth: 600, 
              traceSVG: {optTolerance: 10, blackOnWhite: true},
            ) {
              ...GatsbyImageSharpSizes_noBase64
            }
          }
        }
      }
      textbox_product_title
      textbox_product_id
      textbox_product_teaser
      textbox_product_text
      
      kontakt_title
      kontakt_teaser
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js